import { useQuery } from "@apollo/client";
import { ADMIN_USERNAME } from "../constants/admin";
import { GET_ME } from "../query/UserQueries";

/**
 * Vrai si l'utilisateur courant est administrateur.
 *
 * On privilégie le flag serveur `me.isAdmin` (calculé par config/isAdministrator :
 * ADMIN_EMAIL ou pseudo admin), et on retombe sur la comparaison de pseudo pour
 * les cas où le champ ne serait pas encore chargé.
 */
export const useIsAdmin = () => {
  const { data } = useQuery(GET_ME);
  const currentUser = data?.me;
  if (!currentUser) return false;
  return !!currentUser.isAdmin || currentUser.username === ADMIN_USERNAME;
};
